import script from "./ProductDetailVariantModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailVariantModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailVariantModal.vue?vue&type=style&index=0&id=5ce49be7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce49be7"]])

export default __exports__